/* eslint-disable import/no-extraneous-dependencies */
import { GlobalWorkerOptions } from 'pdfjs-dist';

export { type PDFDocumentProxy, getDocument } from 'pdfjs-dist';
export {
  type DocumentInitParameters,
  type TypedArray
} from 'pdfjs-dist/types/src/display/api';

GlobalWorkerOptions.workerSrc = 'assets/common/js/pdf.worker.min.js';

export { GlobalWorkerOptions };
